/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 08:49:16
 * @LastEditTime: 2022-06-10 14:23:01
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/MissingPageRedirection/index.tsx
 */
import { Button, Form } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { save_missingPageRedirection } from '@/src/request/salesChannel/setting/domain';
import { Icon } from '@/src/tools/icon';
import {
  MissingPageRedirectType,
  MissingPageType,
} from '@/src/types/common/domain';
import { LinkModuleType } from '@/src/types/common/linkType';
import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
import { redirectColumns } from './config';

const { List } = Form;
interface EditableTableProps {
  value?: any;
  fields: any;
  modalOp?: any;
  form: any;
  edit: boolean;
  setEdit: any;
}

const EditableTableInForm = ModalHoc(
  ({ form, fields, edit, modalOp, setEdit }: EditableTableProps) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const { setShowModal, setModalTitle, setModalContent } = modalOp || {};
    const params: any = useParams();

    const { uuid: salesChannelUuid } = params;
    const handleMissingPageOnCahnge = (selectValue, dataValue, index) => {
      setShowModal(true);
      setModalTitle(getI18n('general.linkModule.Modal.link'));
      setModalContent(
        <LinkLibrary
          mode={'no-modal'}
          middleText={getI18n('general.sider.externalLink')}
          containerClassName={css.linkLibrary}
          title={`${getI18n('general.linkModule.Modal.link')}*`}
          linkSet={{
            scopeVariables: { SalesChannel: salesChannelUuid },
            linkTypeFilter:
              dataValue.missingPageType ==
              MissingPageType.NoAvailableContentVersion
                ? [LinkModuleType.LinkLibrary]
                : [
                    LinkModuleType.HomePage,
                    LinkModuleType.AllProducts,
                    LinkModuleType.LinkLibrary,
                  ],
          }}
          data={dataValue.linkModule || {}}
          onChange={(value) => {
            setShowModal(false);
            setEdit(true);
            form.setFields([
              {
                name: ['missingPageRedirections', index],
                value: {
                  ...dataValue,
                  linkModule: value,
                  missingPageRedirectType: MissingPageRedirectType.OtherPage,
                },
              },
            ]);
          }}
        />,
      );
    };

    return (
      <Fragment>
        <EditableTable
          id='missingPageRedirections'
          dataSource={fields}
          columns={redirectColumns(
            fields,
            handleMissingPageOnCahnge,
            edit,
            form,
            { getI18n },
            // linkListData,
          )}
          rowKey={(record) => record.missingPageType}
          pagination={false}
        />
      </Fragment>
    );
  },
);

const MiniProgramMissingPageRedirection = ({
  disabled,
  missingPageRedirections,
}) => {
  const i18n = useI18n();
  const [form] = Form.useForm();
  const params: any = useParams();
  const { uuid: salesChannelUuid } = params;
  const [hasModified, setHasModified] = useState<boolean>(false);
  const [fold, setFold] = useState<boolean>(false);
  const getI18n = (str) => i18nGet(i18n, str);
  const handleCancel = () => {
    form.resetFields();
    setHasModified(false);
  };
  const onFinish = (values) => {
    save_missingPageRedirection({ ...values, salesChannelUuid }).then(
      (data) => {
        setHasModified(false);
      },
    );
  };

  return (
    <Form
      form={form}
      initialValues={{ missingPageRedirections }}
      onFinish={onFinish}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.containerClassName}
        titleOnClick={() => setFold(!fold)}
        hideContent={!fold}
        rightPart={<Icon type={fold ? 'icondown1' : 'iconright'} />}
        title={getI18n(
          'salesChannelMiniProgramSettings.index.miniProgramMissingPageRedirection',
        )}
        subtitle={getI18n(
          'salesChannelMiniProgramSettings.index.miniProgramMissingPageRedirectionTips',
        )}>
        <List name='missingPageRedirections'>
          {(fields) => {
            return (
              <EditableTableInForm
                edit={hasModified}
                setEdit={setHasModified}
                fields={fields}
                form={form}
              />
            );
          }}
        </List>
        <div className={css.buttonCombin}>
          {!hasModified && (
            <Button
              disabled={disabled}
              type='primary'
              onClick={() => setHasModified(true)}>
              {getI18n('general.edit')}
            </Button>
          )}
          {hasModified && (
            <Button
              disabled={disabled}
              type='primary'
              onClick={() => form.submit()}>
              {getI18n('general.confirm')}
            </Button>
          )}
          {hasModified && (
            <Button className={css.last} onClick={handleCancel}>
              {getI18n('general.cancel')}
            </Button>
          )}
        </div>
      </SectionWrapper>
    </Form>
  );
};
export default MiniProgramMissingPageRedirection;
